const { format: formatDate } = require("date-fns");

export const formatDateTimeISO = (dateTime = new Date()) => {
  return formatDate(dateTime, "yyyy-MM-dd HH:mm:ss");
};
